import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { CloseOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { ModalWrapper } from './styled'
import { PrimaryButton, OutlineButton } from '../../../../components/button'
import { SelectButton } from '../select-button'

export const ModalRequester = ({
  t,
  requesterList,
  selectedRequester,
  setSelectedRequester,
  registeredRequester,
  setRegisteredRequester,
  isModalVisible,
  setIsModalVisible
}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const requester = useMemo(
    () => requesterList.filter(({ name }) => name.toLowerCase().includes(searchTerm.toLowerCase())),
    [requesterList, searchTerm]
  )

  const handleSelectRequester = (id) => {
    setSelectedRequester(requesterList.find((item) => item.id === id))
  }

  const handleSearch = (e) => {
    setSearchTerm(e.target.value)
  }

  const handleOk = () => {
    setIsModalVisible(false)
    setRegisteredRequester(selectedRequester)
    setSearchTerm('')
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    setSelectedRequester(registeredRequester)
    setSearchTerm('')
  }

  const Footer = () => (
    <div className="footer">
      <PrimaryButton onClick={handleOk} title={t('task.save')} />
      <OutlineButton onClick={handleCancel} title={t('task.cancel')} />
    </div>
  )

  return (
    <ModalWrapper
      centered
      open={isModalVisible}
      onCancel={handleCancel}
      title={t('task.select_requester')}
      footer={<Footer />}
    >
      <div className="content-wrapper">
        <div className="filter">
          <div className="search">
            <input onChange={handleSearch} value={searchTerm} placeholder={`${t('task.search')}...`} type="search" />

            <Tooltip title={t('task.clear')}>
              <button type="button" onClick={() => setSearchTerm('')}>
                <CloseOutlined />
              </button>
            </Tooltip>
          </div>
        </div>

        <div className="requester-list">
          {requester.length === 0 && <div style={{ fontSize: 13, color: '#aaa' }}>{t('task.no_search_result')}</div>}
          {requester.map(({ id, name }) => (
            <label key={id} className="requester-item" htmlFor={`requester-${id}`} onClick={() => handleSelectRequester(id)}>
              <SelectButton id={`requester-${id}`} selected={selectedRequester?.id === id} />
              {name}
            </label>
          ))}
        </div>
      </div>
    </ModalWrapper>
  )
}

ModalRequester.propTypes = {
  t: PropTypes.func,
  requesterList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired,
  selectedRequester: PropTypes.object,
  setSelectedRequester: PropTypes.func,
  registeredRequester: PropTypes.object,
  setRegisteredRequester: PropTypes.func,
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func
}
